
import {
  CompoundProductionStepDto,
  CreateCompoundProductionStepDto,
  UpdateCompoundProductionStepDto,
} from './dtos'
import { BaseCrudService } from './BaseCrudService'
import { PaginatedQueryBase } from './api'

export type CompoundProductionStepsFilters = PaginatedQueryBase & {
  includeInactive?: boolean
  search?: string
}

class CompoundProductionStepService extends BaseCrudService<
  CompoundProductionStepDto,
  CreateCompoundProductionStepDto,
  UpdateCompoundProductionStepDto,
  CompoundProductionStepsFilters
> {
  constructor() {
    super('compound-production-step', process.env.REACT_APP_RADIOPHARMACY_API_URL)
  }
}

export const compoundProductionStepService = new CompoundProductionStepService()
